"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormLinkTracking = /** @class */ (function () {
    function FormLinkTracking() {
        var _this = this;
        this.inputs = [];
        this.urlParams = new URLSearchParams(window.location.search);
        this.inputs = Array.from(document.querySelectorAll('input'));
        this.inputs
            .filter(function (input) { return input.hasAttribute('data-input-hidden'); })
            .forEach(function (input) {
            _this.fillHiddenInput(input);
        });
    }
    /**
     * Check if URL Params are set and fill Hidden Input with utm_campaign value
     */
    FormLinkTracking.prototype.fillHiddenInput = function (el) {
        var _a, _b, _c;
        var utmMedium = (_a = this.urlParams.get("mtm_medium")) !== null && _a !== void 0 ? _a : undefined;
        var utmSource = (_b = this.urlParams.get("mtm_source")) !== null && _b !== void 0 ? _b : undefined;
        var utmCampaign = (_c = this.urlParams.get("mtm_campaign")) !== null && _c !== void 0 ? _c : undefined;
        if (utmMedium == 'email' && utmSource == 'mailing' && utmCampaign) {
            el.value = utmCampaign;
        }
        else {
            el.value = '-';
        }
    };
    return FormLinkTracking;
}());
exports.default = FormLinkTracking;
